import { useEffect, useState } from 'react';
import { getAccessToken } from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Descarga una imagen protegida (requiere cabeceras de autenticación) y devuelve una URL local para <img>.
 * `version` cambia cuando la empresa sube otro logo, para no mostrar uno antiguo.
 */
export function useProtectedImage(url: string | null, version: string | null | undefined, headers: () => Record<string, string>) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    if (!url || !version) {
      setSrc(null);
      return;
    }
    let objectUrl: string | null = null;
    let cancelled = false;
    fetch(`${url}?v=${encodeURIComponent(version)}`, { headers: headers() })
      .then((r) => (r.ok ? r.blob() : null))
      .then((b) => {
        if (!b || cancelled) return;
        objectUrl = URL.createObjectURL(b);
        setSrc(objectUrl);
      })
      .catch(() => setSrc(null));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, version]);
  return src;
}

/** Logo de la empresa del usuario (si lo ha subido). No muestra nada si no hay logo. */
export function CompanyLogo({ className = 'h-8 max-w-[140px]', tile = false }: { className?: string; tile?: boolean }) {
  const { me } = useAuth();
  const src = useProtectedImage('/api/v1/company/logo', me?.company?.logoVersion, () => ({ authorization: `Bearer ${getAccessToken() ?? ''}` }));
  if (!src) return null;
  const img = <img src={src} alt={`Logo de ${me?.company?.name ?? 'la empresa'}`} className={`${className} object-contain`} />;
  return tile ? <span className="inline-flex shrink-0 items-center justify-center rounded-lg bg-white p-1.5">{img}</span> : img;
}
